<div class="fk-tree-view-item">
  @if (minimized) {
    <a class="fk-tree-view-item--minimized-btn fk-pv2">
      <div class="fk-tree-view-item--icon">
        @if (item.icon) {
          <fk-icon [name]="item.icon"></fk-icon>
        }
      </div>
    </a>
  } @else {
    @if (!isRootItem) {
      <div
        class="fk-tree-view-item--structural"
        [class.fk-tree-view-item--structural__last]="isLastItem"></div>
    }
    <div class="fk-tree-view-item--addons">
      <ng-content></ng-content>
    </div>
    @if (item.icon) {
      <div class="fk-tree-view-item--icon">
        <fk-icon [name]="item.icon"></fk-icon>
      </div>
    }
    <div class="fk-tree-view-item--label fk-subtitle1 fk-ml3">
      @if (item.link) {
        <a
          class="fk-tree-view-item--link"
          [routerLink]="item.link"
          routerLinkActive="fk-tree-view-item--link__active">
          {{ item.label }}
        </a>
      } @else {
        <span>{{ item.label }}</span>
      }
    </div>
  }
</div>